import React from "react";
import { Snackbar, Alert } from "@mui/material";

function ResultBar(props: any) {
  const { open, handleClose, result, successMessage, errorMessage } = props;
  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      {result ? (
        <Alert elevation={3} variant="filled" severity="success">
          {successMessage}
        </Alert>
      ) : (
        <Alert elevation={3} variant="filled" severity="error">
          {errorMessage}
        </Alert>
      )}
    </Snackbar>
  );
}

export default ResultBar;
